import { produce } from "immer";
import MetaData from "./MetaData";

const utils = (context) => {
  return {};
};

const main = (context) => {
  const { dispatch, rootGetters, current } = context;
  return {
    async set(icon, range) {
      let cellIds = rootGetters["cells/rangeIds"](range).filter((id) => !rootGetters["cells/isCellDisabled"](id));
      const prevMetaData = {};
      current.design.cellsMetaData = produce(current.design.cellsMetaData, (cellsMetaData) => {
        let firstCellIcon =
          current.design.cellsMetaData[cellIds[0]]?.icons !== undefined
            ? current.design.cellsMetaData[cellIds[0]].icons
            : "";
        firstCellIcon = firstCellIcon.split(",");
        let firstCellIconIndex = firstCellIcon.indexOf(icon);
        cellIds.forEach((id) => {
          id = id.replace("_merged", "");
          prevMetaData[id] = current.design.cellsMetaData[id];
          let cellIcons =
            current.design.cellsMetaData[id]?.icons !== undefined ? current.design.cellsMetaData[id].icons : "";
          cellIcons = cellIcons.split(",");
          const index = cellIcons.indexOf(icon);

          if (firstCellIconIndex === -1) {
            if (index === -1) cellIcons.push(icon);
          } else {
            if (index !== -1) cellIcons.splice(index, 1);
          }
          if (!cellsMetaData[id]) cellsMetaData[id] = {};
          cellsMetaData[id].icons = cellIcons.join(",");
        });
      });
      dispatch("cells/toggleRedrawCanvas", null, { root: true });
      await dispatch("cells/persistCellsMetaData", cellIds, { root: true });
      return async () => {
        current.design.cellsMetaData = { ...current.design.cellsMetaData, ...prevMetaData };
        await dispatch("cells/persistCellsMetaData", cellIds, { root: true });
        dispatch("cells/toggleRedrawCanvas", null, { root: true });
      };
    },
    async add(cellIds, icon) {
      const cellsMetaData = { ...current.design.cellsMetaData };

      cellIds.forEach((cellId) => {
        cellsMetaData[cellId] = { icons: icon };
      });
      current.design.cellsMetaData = cellsMetaData;
      await dispatch("persistCellsMetaData", cellIds);

      return async () => {
        await MetaData(context).main.removeProperty(cellIds, "icons");
      };
    },
  };
};
export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
